import React from "react";

/**
 * FilterTabs — segmented control matching LiveTracking style.
 *
 *  - value: current selected key
 *  - onChange(key)
 *  - options: [{ key, label, count?, disabled? }]
 *  - tone: "yellow" (default selected = #FFC60A) | "navy" (selected = zinc-900)
 *  - full: stretch to fill row
 */
export function FilterTabs({
  value,
  onChange,
  options = [],
  tone = "yellow",
  full = false,
  size = "md",
  className = "",
  testIdPrefix,
}) {
  const sizeCls = size === "sm" ? "py-1 text-[9px]" : "py-1.5 text-[10px]";
  return (
    <div
      className={`inline-grid grid-flow-col auto-cols-fr border border-zinc-900 font-bold uppercase tracking-widest ${full ? "w-full" : ""} ${className}`}
    >
      {options.map((opt) => {
        const active = value === opt.key;
        const activeCls =
          tone === "navy"
            ? "bg-zinc-900 text-white"
            : "bg-[#FFC60A] text-zinc-900";
        return (
          <button
            key={opt.key}
            type="button"
            disabled={opt.disabled}
            onClick={() => onChange(opt.key)}
            data-testid={testIdPrefix ? `${testIdPrefix}-${opt.key}` : undefined}
            className={`${sizeCls} px-2 border-r border-zinc-900 last:border-r-0 transition-colors flex items-center justify-center gap-1.5 ${
              active ? activeCls : "bg-white text-zinc-900 hover:bg-zinc-100"
            } ${opt.disabled ? "opacity-40 cursor-not-allowed" : ""}`}
          >
            <span className="truncate">{opt.label}</span>
            {opt.count != null && (
              <span className={`text-[9px] font-mono px-1 border ${active ? "border-zinc-900/40" : "border-zinc-300"}`}>
                {opt.count}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}
